export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00986.30ae5044.png";